/* eslint-disable */
import { notifyModulesConfigFailed, notifyModulesConfigLoaded } from './modulesConfigReady';
import './mfRemote';
import { createFetcher } from '@/components/utils/fetcher';

type Modules = {
  refundCustomerUrl: string;
  postSaleChangesUrl: string;
  postSaleBaggageUrl: string;
  profileUrl: string;
  involuntaryChangesUrl: string;
  refundlyUrl: string;
};

export const init = async (): Promise<void> => {
  if (__DEV__) {
    import(/* webpackChunkName: "hmr-indicator" */ './HotReloadIndicator');
    const { setupMocks } = await import(/* webpackChunkName: "setup-mocks" */ '../mocks/setupMocks');
    await setupMocks();
  }
  import(/* webpackChunkName: "render-app" */ './renderApp');

  try {
    const modulesResponse = await createFetcher<Modules>({
      url: '/cia-be/api/v1/modules',
      name: 'modules-configuration',
    })();
    window.customModules = await modulesResponse.json();
    notifyModulesConfigLoaded();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error retrieving modules configuration', e);
    notifyModulesConfigFailed(e);
  }
};

init();
